function render(el, cb) {
  if (!el) {
    throw new Error("You must define a dom object.");
  }

  // Accept a NodeList or an Array of nodes (importModule now filters matches to
  // an Array); both expose forEach.
  if (typeof el !== "object" || typeof el.forEach !== "function") {
    throw new TypeError("This method requires a NodeList or Array of nodes.");
  }

  if (!cb) {
    throw new Error("You must define a callback method.");
  }

  if (typeof cb !== "function") {
    throw new TypeError("You must provide a Function.");
  }

  el.forEach(cb);
}

export default render;
